<script>
import { version } from "../../../package.json"
import { mapState } from 'vuex'
import { isMobile, mobileVendor, mobileModel } from 'mobile-device-detect'
import axios from 'axios';

export default {
  name: 'Login',
  data() {
    return {
      validacao: false,
      validacaoCidade: false,
      validacaoNome: false,
      validacaoSenha: false,
      estilo_icones_legivel: 'outline-primary',
      login: '',
      estilo_password: 'password',
      estilo_legivel: 'eye',
      isMobile: isMobile,
      mobileModel: mobileModel,
      mobileVendor: mobileVendor,
      gettingLocation: false,
      usarLocalizacao: false,
      appVersion: version,
      loggedIn: true,
      errorStr: '',
      cidades: [{ 
          text: 'Escolha Cidade',
          value: null
        }, {
          text: "Arapongas",
          value: "Arapongas"
        }, {
          text: "Boa Vista",
          value: "BoaVista"
        }, {
          text: "Boa Vista Anjo",
          value: "BoaVista_Anjo"
        }, {
          text: "Campo Mourão",
          value: "CampoMourao"
        }, {
          text: "Cianorte",
          value: "Cianorte"
        }, {
          text: "Cianorte Anjo",
          value: "Cianorte_Anjo"
        }, {
          text: "Cianorte Cerca",
          value: "Cianorte_Cerca"
        }, {
          text: "Dourados",
          value: "Dourados"
        }, {
          text: "Itaipu",
          value: "Itaipu"
        }, {
          text: "Macae",
          value: "Macae"
        }, {
          text: "Maringa",
          value: "MARINGA"
        }, {
          text: "Nova Friburgo",
          value: "NovaFriburgo"
        }, {
          text: "Sarandi",
          value: "Sarandi"
        }, {
          text: "Paranavai",
          value: "Paranavai"
        }, {
          text: "São José",
          value: "SaoJose"
        }, {
          text: "Umuarama",
          value: "Umuarama"
        }, {
          text: "Umuarama Anjo",
          value: "Umuarama_Anjo"
        }],
    }
  },
  computed: {
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      clientinfo: state => state.moduleLogin.clientinfo
    }),
    cidade(){
      return this.user.cidade
    },
    nome(){
      return this.user.username
    },
    senha() {
      return this.user.password
    }
  },
  watch:{
    errorStr(){
      this.$swal.fire({
        title: "Login",
        text: 'Necessário Liberar o acesso a localização',
        icon: "error"
      })
    },
    cidade() {
      if (this.user.cidade == null){
        this.validacaoCidade = false
      }else{
        this.validacaoCidade = true
      }
      this.validacaoGeral()
    },
    nome() {
      if (this.user.username == ''){
        this.validacaoNome = false
      }else{
        this.validacaoNome = true
      }
      this.validacaoGeral()
    },
    senha () {
      if (this.user.password == ''){
        this.validacaoSenha = false
      }else{
        this.validacaoSenha = true
      }
      this.validacaoGeral()
    }

  },
  methods: {
    validacaoGeral() {
      this.validacao = this.validacaoCidade && this.validacaoNome && this.validacaoSenha
    },
    status_visivel () {
      if (this.estilo_password == 'password')
      {
        this.estilo_password = 'text'
        this.estilo_legivel = 'eye-slash'
        this.estilo_icones_legivel = 'outline-danger'
      }
      else
      {
        this.estilo_password = 'password'
        this.estilo_legivel= 'eye'
        this.estilo_icones_legivel = 'outline-primary'
      }
    },
    //clicklogin: function() {
    //  var e = this;
    //  this.recaptchaValidacao && this.$recaptcha("login").then((function() {
    //      e.$emit("login", e.user)
    //  }))
    //}
    entrar(){
      if (this.usarLocalizacao) {
        var user = this.user
        var clientinfo = this.clientinfo
        const aqui = this
        //const token = this.$recaptcha('login') 
        aqui.$store.dispatch("LOGIN", {user, clientinfo}).then((function(e) {
          if (e['login'] == 'false')  
            aqui.$swal.fire({
              title: "Login",
              text: e['mensagem'],
              icon: "error"
            })
          //else if (this.mobile && 17 == e["codUsuario"]) {
          //    var t = this.user.cidade;
          //    this.$store.dispatch("PESQUISALPRBOTBACKEND", {
          //        value: e,
          //        cidade: t
          //    }).then((function(e) {
          //        0 == e.cadastro && this.alertDisplay(e.senhaCadastro)
          //    }))
          //}
        }))
      } else
        if(this.showAlertLocalizacao == false){
          this.$notify({
          group: "localizacao",
          type: "error",
          title: "Permitir acesso da localização",
          text: "Por motivos de segurança isso é necessário",
          duration: 1e4,
          speed: 1e3
        })
      } 
    },
    pegarLocalizacao() {
      if ("geolocation" in navigator){
        if (this.gettingLocation == false){
          navigator.geolocation.watchPosition((function(e) {
            this.usarLocalizacao = true 
            this.gettingLocation = false
            this.clientinfo.latitude = e.coords.latitude
            this.clientinfo.longitude = e.coords.longitude
          }), (function(e) {
            this.gettingLocation = false
            this.errorlocalizacao = e.message
            this.usarLocalizacao = false
          }));
        }
      }
      else{
        alert("Localizacao nao é valida.")
      }
    },
    getOS() {
      const userAgent = navigator.userAgent;
      if (userAgent.indexOf('Win') !== -1) return 'Windows';
      if (userAgent.indexOf('Mac') !== -1) return 'MacOS';
      if (userAgent.indexOf('X11') !== -1 || userAgent.indexOf('Linux') !== -1) return 'Linux';
      if (userAgent.indexOf('Android') !== -1) return 'Android';
      if (userAgent.indexOf('like Mac') !== -1) return 'iOS';

      return 'Unknown OS';
    },
    async getIP() {
      try {
        const response = await axios.get('https://api.ipify.org?format=json');
        this.clientinfo.ip = response.data.ip;
        //let ip = this.clientinfo.ip
        //this.$store.dispatch("CLIENTINFO", {ip})

      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    },
    async convertCoordsToAddress(latitude, longitude) {
      this.address = '';
      this.error = '';
      const lat = parseFloat(latitude);
      const lon = parseFloat(longitude);
      if (isNaN(lat) || isNaN(lon)) {
        this.error = 'Please enter valid latitude and longitude values.';
        return;
      }

      try {
        const apiKey = '';//'AIzaSyBa3e9RoiFWUdDZk2-ZOh915qtsRBKFq70'; // Replace with your Google Maps API Key
        const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=${apiKey}`);
        
        if (response.data.status === 'OK') {
          this.address = response.data.results[0].address_components;
          this.clientinfo.street = this.address[1].short_name 
          this.clientinfo.city = this.address[3].short_name 
          this.clientinfo.region = this.address[3].long_name
          this.clientinfo.region_code = this.address[3].short_name
          this.clientinfo.country = this.address[6].long_name
          this.clientinfo.country_code = this.address[5].short_name
          this.clientinfo.country_name = this.address[5].long_name
        } else {
          this.error = 'Unable to retrieve address for these coordinates.';
        }
      } catch (error) {
        console.error('Error fetching address:', error); 
        this.error = 'Error fetching address.';
      }
    }
  },
  mounted() {
    this.user.loggedIn = false
    //this.$store.dispatch('CLIENTINFO').then((resolve) => { this.localIp = resolve.ip })
    if(!("geolocation" in navigator)) {
      this.errorStr = 'Geolocalização não disponível.';
      this.clientinfo.latitude = -1;
      this.clientinfo.longitude = -1;
      return;
    }
    this.gettingLocation = false;
    // get position
    navigator.geolocation.getCurrentPosition(pos => {
      this.gettingLocation = true
      this.usarLocalizacao = true
      this.clientinfo.latitude = pos.coords.latitude
      this.clientinfo.longitude = pos.coords.longitude
      this.convertCoordsToAddress(this.clientinfo.latitude, this.clientinfo.longitude)
    }, err => {
      this.gettingLocation = false
      this.usarLocalizacao = false
      this.errorStr = err.message
      this.clientinfo.latitude = -1
      this.clientinfo.longitude = -1
    })
    if (this.isMobile) {
      this.clientinfo.is_mobile = this.isMobile
      this.clientinfo.mobile_model = this.mobileModel
      this.clientinfo.mobile_factory = this.mobileVendor
      //this.pegarLocalizacao()
    }
    this.clientinfo.os_name = this.getOS()
    this.getIP()
      //this.mobile && (this.clientinfo.is_mobile = this.mobile, this.clientinfo.mobile_model = this.modelo, this.clientinfo.mobile_factory = this.marca), this.pegarLocalizacao(), this.$store.dispatch("CLIENTINFO");
    //var e = this.header.join(" "),
    //    t = this.comparar(e, this.dataos),
    //    a = this.comparar(e, this.databrowser);
    //this.clientinfo.os_name = t.name, this.clientinfo.browser_version = a.version, this.clientinfo.browser_name = a.name
    //var t = this
    //this.$recaptcha("login").then((function(e) { 
    //    t.user.token = e, 
    //    t.recaptchaValidacao = true
    //  })
    //  ).catch(
    //    this.recaptchaValidacao = false
    //  )
  }
  
}
</script>

<template>
  <b-card class="login-card col-xl-4 col-md-6 col-sm-10 mx-auto my-auto">
    <b-form class="form-login">
      <b-form-group>
        <b-input-group class="mb-2 shadow rounded">
          <b-input-group-prepend is-text>
            <b-icon icon="geo-alt-fill"></b-icon>
          </b-input-group-prepend>
          <b-form-select v-model="user.cidade" :options="cidades"></b-form-select>
        </b-input-group>
        
        <b-input-group class="mb-2 shadow rounded">
           <b-input-group-prepend is-text>
            <b-icon icon="person-fill"></b-icon>
          </b-input-group-prepend>
          <b-form-input v-model="user.username"  @input="(val) => (user.username = user.username.toLowerCase())" placeholder="Usuário" @keyup.enter="entrar"/> 
        </b-input-group>

        <b-input-group class="mb-2 shadow rounded">
          <b-input-group-prepend is-text>
            <b-icon icon="key-fill"></b-icon>
          </b-input-group-prepend>
          <b-form-input v-model="user.password" placeholder="Senha" :type="estilo_password" @keyup.enter="entrar"/> 
          <b-input-group-append>
            <b-button :variant="estilo_icones_legivel" @click="status_visivel" size="sm"><icon :name="estilo_legivel"/></b-button>
          </b-input-group-append>
        </b-input-group>
        
        <b-button class="button-login shadow rounded" :disabled='!validacao' @click="entrar" :variant="validacao ? 'success' : ''">Entrar</b-button>
        <p class="estiloRodape"><span class="shadow rounded">Versão: {{ appVersion }}</span> </p>
      </b-form-group>
    </b-form>
  </b-card>
</template>

<style scoped>
  .login-card {
    display: inline-block;
    border-color: lightgrey;
    background-color: ghostwhite;
    /*margin-top: 10% !important;*/
  }
  @media screen and (max-width: 500px){
    .login-card {
      border: none;
      width: 95vw;
    }
  }
  
  .button-login {
    padding: 15px 20px;
    box-sizing: border-box;
    width: 100%;
  }

.estiloRodape {
  color: rgb(158, 154, 154) !important;
  text-align: right;
}
</style>